import useMouseEvents from '@/roadmaps/use/use-mouse-events';
import { ref } from 'vue';

const isSomethingBeingResized = ref(false);

export default function useResizable () {
    let isResizing;
    let resizeAction;
    let onBeforeResizeStart = () => {};
    let onResizeStart = () => {};
    let onResizing = () => {};
    let onResizeStop = () => {};
    let onAfterResizeStop = () => {};

    const registerEvents = (events) => {
        if (events.onBeforeResizeStart) onBeforeResizeStart = events.onBeforeResizeStart;
        if (events.onResizeStart) onResizeStart = events.onResizeStart;
        if (events.onResizeStop) onResizeStop = events.onResizeStop;
        if (events.onResizing) onResizing = events.onResizing;
        if (events.onAfterResizeStop) onAfterResizeStop = events.onAfterResizeStop;
    };

    const onMouseMove = (event) => {
        event.preventDefault();
        if (!isResizing) {
            isResizing = true;
            isSomethingBeingResized.value = true;
            onResizeStart({
                resizeAction,
            });
        }

        onResizing({
            pageX: Math.floor(event.pageX),
            resizeAction,
        });
    };

    const onPointerUp = (event) => {
        event.preventDefault();

        const { removeMouseMoveHandler } = useMouseEvents();
        removeMouseMoveHandler(onMouseMove);

        window.removeEventListener('pointerup', onPointerUp);
        document.body.style.cursor = 'initial';

        if (isResizing) {
            onResizeStop();
            isSomethingBeingResized.value = false;
            isResizing = false;
        }
        onAfterResizeStop();
    };

    const onResize = (event, action) => {
        if (event.button !== 0) return;

        event.preventDefault();

        onBeforeResizeStart({
            resizeAction,
            pageX: Math.floor(event.pageX),
            pageY: Math.floor(event.pageY),
        });

        const { addMouseMoveHandler } = useMouseEvents();
        addMouseMoveHandler(onMouseMove);

        window.addEventListener('pointerup', onPointerUp);
        document.body.style.cursor = 'ew-resize';

        resizeAction = action;
    };

    return {
        registerEvents,
        onResize,

        isSomethingBeingResized,
    };
}
